import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { Subscription } from 'rxjs';
import { getSetupMnemonic } from '../../../angular-wallet-base/store/setup';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
@Component({
    selector: 'setup-recovery-phrase',
    templateUrl: 'setup-recovery-phrase.page.html',
    styleUrls: ['setup-recovery-phrase.page.scss']
})
export class SetupRecoveryPhrasePage implements OnInit, OnDestroy {

    public mnemonic;
    private subscriptions = new Subscription();
    public hasStoredPhrase = false;
    public isDesktopMode;

    constructor(private store: Store<AppState>, private appMode: AppModeService,) {
        this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    }

    ngOnInit() {
        this.subscriptions.add(this.store.select(getSetupMnemonic).subscribe(mnemonic => this.mnemonic = mnemonic));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
